// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';
import classNames from '@ta/common.classnames';

import FeedSectionItemLoadingSkeleton from './FeedSectionItemLoadingSkeleton';

import styles from './ShelfItemsLoadingSkeleton.less';

type Props = {
  items: number,
};

// Create a single element skeleton loader.
const ShelfItemsLoadingSkeleton = (props: Props) => {
  const skeletons = [];
  const column = 12 / props.items;

  // Using a plain-old-for-loop here for perf reasons.
  for (let i = 0; i < props.items; i++) {
    skeletons.push(
      <div className={classNames('ui_column', `is-${column}`, styles.wrapper)} key={i}>
        <FeedSectionItemLoadingSkeleton />
      </div>,
    );
  }

  return skeletons;
};

export default ShelfItemsLoadingSkeleton;
